import Card from './Card'

export { Card }
export default Card



// WEBPACK FOOTER //
// ./src/components/Card/index.js